import { FC, useMemo } from 'react';
import { Threshold } from './models';
import { MAGNETIC_TOKENS } from '@appd/uik';
import { PADDING, SPACING, TableColumn } from '../DataGrid';
import { Table } from '@tanstack/react-table';
import { DEFAULT_THRESHOLDS } from './constants';
import { useThreshold } from './useThreshold';

const { COLORS } = MAGNETIC_TOKENS;

interface BgColorCellRendererProps {
  value: string;
  thresholds: Threshold[];
  table: Table<TableColumn>;
}

export const BgColorCellRenderer: FC<BgColorCellRendererProps> = ({
  value,
  thresholds = DEFAULT_THRESHOLDS,
  table,
}): JSX.Element => {
  const threshold = useThreshold(thresholds, value);
  const spacing = useMemo(() => (table?.options?.meta?.spacing as SPACING) ?? SPACING.COMPACT, [table]);
  const padding = useMemo(() => PADDING[spacing], [spacing]);
  const color = useMemo(() => threshold && threshold.color, [threshold]);

  return (
    <div
      style={{
        backgroundColor: color ?? COLORS.DEFAULT_BG,
        // padding and margins need to be adjusted due to Grid.tsx adding padding
        padding: padding,
        margin: -padding,
      }}
    >
      <p>{value}</p>
    </div>
  );
};
